import { clsx } from 'clsx';
import type { DashboardQuelle } from '@/types/dashboard';

type Props = {
  wert: DashboardQuelle;
  onChange: (q: DashboardQuelle) => void;
};

// "Glomer" ist der Shop, "Laden" alles, was nicht von dort kommt.
// Die Beschriftung nimmt bewusst die Worte der Mitarbeiter auf, nicht
// die technischen Codes.
const REITER: { wert: DashboardQuelle; label: string }[] = [
  { wert: 'alle', label: 'Alle' },
  { wert: 'laden', label: 'Laden' },
  { wert: 'glomer', label: 'Glomer' }
];

export function QuelleTabs({ wert, onChange }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Herkunft der Bestellungen"
      data-tour="dashboard-quelle"
      className="inline-flex overflow-hidden rounded-md border border-line"
    >
      {REITER.map((r) => (
        <button
          key={r.wert}
          type="button"
          role="tab"
          aria-selected={wert === r.wert}
          onClick={() => onChange(r.wert)}
          className={clsx(
            'min-h-[44px] px-4 text-sm transition-colors',
            wert === r.wert
              ? 'bg-akzent text-cream'
              : 'bg-cream text-ink-soft hover:bg-cream-dark hover:text-ink'
          )}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
